export default {
  mounted () {
    window.scrollTo(0, 0)
  }
}
